import React, { Component } from 'react';
import axios from 'axios';
import labels from './labels.json';
import './SearchBeatLearningPage.css';

export function operationId() {
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export class SearchBeatLearningPage extends Component {
    state = {
        control: null, loading: false, busy: false, inspecting: false, error: '', success: '',
        version: '', model: null, mode: 'OFF', traffic: '0', experiment: '', autoPromote: false,
        scope: 'com.vnapp.iKara', source: '', target: '', beatId: '', blockType: 'REWRITE', reason: ''
    };
    mounted = false;
    pending = null;
    locked = false;
    modelRequest = 0;

    componentDidMount() { this.mounted = true; this.loadState(); }
    componentWillUnmount() { this.mounted = false; this.modelRequest++; }
    text = key => labels[key];
    endpoint = path => global.config.apiDomain + '/yt-song/web/search-beat-learning' + path;
    data = response => {
        if (!response.data || response.data.status !== 'OK' || !response.data.data) {
            const error = new Error(response.data && response.data.message || this.text('failed'));
            error.response = response;
            throw error;
        }
        return response.data.data;
    };
    message = error => error.response && error.response.data && error.response.data.message
        || error.message || this.text('failed');
    acceptState = control => {
        if (this.mounted) this.setState({ control, mode: control.mode, traffic: String(control.trafficPercent),
            experiment: control.experimentId || '', autoPromote: Boolean(control.autoPromoteEnabled) });
    };
    loadState = async () => {
        if (this.locked || this.state.loading) return;
        this.setState({ loading: true, error: '' });
        try { this.acceptState(this.data(await axios.get(this.endpoint('/state')))); }
        catch (error) { if (this.mounted) this.setState({ error: this.message(error), control: null }); }
        finally { if (this.mounted) this.setState({ loading: false }); }
    };
    loadModel = async version => {
        const value = version.trim();
        if (!value) return;
        const id = ++this.modelRequest;
        this.setState({ version: value, model: null, inspecting: true, error: '' });
        try {
            const model = this.data(await axios.get(this.endpoint('/models/' + encodeURIComponent(value))));
            if (this.mounted && id === this.modelRequest) this.setState({ model });
        } catch (error) {
            if (this.mounted && id === this.modelRequest) this.setState({ error: error.response && error.response.status === 404
                ? this.text('notFound') : this.message(error) });
        } finally { if (this.mounted && id === this.modelRequest) this.setState({ inspecting: false }); }
    };
    changeVersion = value => {
        this.modelRequest++;
        this.setState({ version: value, model: null, inspecting: false });
    };
    submit = (path, body, summary) => {
        if (this.locked || this.pending || this.state.loading || !this.state.control) return;
        const reason = this.state.reason.trim();
        if (!reason || reason.length > 1000) { this.setState({ error: this.text('reasonRequired') }); return; }
        if (!window.confirm(summary)) return;
        this.pending = { path, body: { ...body, operationId: operationId(),
            expectedRevision: this.state.control.revision, reason } };
        return this.sendPending();
    };
    sendPending = async () => {
        if (!this.pending || this.locked) return;
        this.locked = true;
        this.setState({ busy: true, error: '', success: '' });
        try {
            const command = this.pending;
            const control = this.data(await axios.post(this.endpoint(command.path), command.body));
            this.pending = null;
            if (this.mounted) {
                this.acceptState(control);
                this.setState({ success: this.text('saved'), reason: '' });
                // Idempotent replay có thể trả revision cũ; đọc lại trạng thái hiện hành.
                try { this.acceptState(this.data(await axios.get(this.endpoint('/state')))); }
                catch (error) { if (this.mounted) this.setState({ control: null, error: this.message(error) }); }
            }
        } catch (error) {
            if (error.response) {
                this.pending = null;
                if (this.mounted) {
                    try { this.acceptState(this.data(await axios.get(this.endpoint('/state')))); }
                    catch (refreshError) { if (this.mounted) this.setState({ control: null }); }
                }
            }
            if (this.mounted) this.setState({ error: this.message(error) });
        } finally {
            this.locked = false;
            if (this.mounted) this.setState({ busy: false });
        }
    };
    activate = () => {
        const { model, version } = this.state;
        if (!model || model.modelVersion !== version.trim() || model.status !== 'READY') return;
        this.submit('/activate', { modelVersion: model.modelVersion }, this.text('confirmActivate') + ' ' + model.modelVersion);
    };
    savePolicy = event => {
        event.preventDefault();
        const { mode, traffic, experiment, autoPromote } = this.state;
        if (!/^\d+$/.test(traffic) || Number(traffic) > 100 || (mode !== 'OFF' && !experiment.trim())) {
            this.setState({ error: this.text('invalidPolicy') }); return;
        }
        this.submit('/policy', { mode, trafficPercent: Number(traffic), experimentId: experiment.trim() || null,
            autoPromoteEnabled: autoPromote }, `${this.text('confirmPolicy')} ${mode} · ${traffic}%`);
    };
    saveBlock = enabled => {
        const { scope, source, target, beatId, blockType } = this.state;
        if (!source.trim() || (blockType === 'REWRITE' ? !target.trim()
            : !/^[1-9]\d{0,18}$/.test(beatId.trim()) || (beatId.trim().length === 19 && beatId.trim() > '9223372036854775807'))) {
            this.setState({ error: this.text('invalidBlock') }); return;
        }
        this.submit('/block', { appScope: scope, sourceIntentKey: source.trim(),
            targetIntentKey: blockType === 'REWRITE' ? target.trim() : null,
            beatId: blockType === 'BEAT' ? beatId.trim() : null, enabled },
        `${this.text(enabled ? 'confirmBlock' : 'confirmUnblock')} ${source.trim()} → ${blockType === 'REWRITE' ? target.trim() : beatId.trim()}`);
    };
    render() {
        const { control, loading, busy, inspecting, error, success, model } = this.state;
        const disabled = busy || loading || Boolean(this.pending) || !control;
        const t = this.text;
        const input = (key, label, type = 'text') => <div className="form-group">
            <label htmlFor={'learning-' + key}>{t(label)}</label>
            <input id={'learning-' + key} className="form-control" type={type} value={this.state[key]}
                maxLength={key === 'reason' ? 1000 : 200} onChange={e => this.setState({ [key]: e.target.value })} />
        </div>;
        return <main className="container learning-admin py-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h1>{t('title')}</h1>
                <button className="btn btn-outline-secondary" disabled={loading || busy} onClick={this.loadState}>{t('refresh')}</button>
            </div>
            <p className="text-muted">{t('intro')}</p>
            {error && <div role="alert" className="alert alert-danger">{error}</div>}
            {success && <div role="status" className="alert alert-success">{success}</div>}
            {this.pending && !busy && <div className="alert alert-warning" role="alert">
                <p>{t('retryHint')}</p><button className="btn btn-warning" onClick={this.sendPending}>{t('retry')}</button>
            </div>}
            {loading && <p role="status">{t('loading')}</p>}
            <section className="card mb-4"><div className="card-body">
                <h2>{t('current')}</h2>
                {control ? <dl className="learning-state">
                    <dt>{t('mode')}</dt><dd><strong>{control.mode}</strong> · {control.trafficPercent}%</dd>
                    <dt>{t('active')}</dt><dd>{control.activeVersion || '—'}</dd>
                    <dt>{t('previous')}</dt><dd>{control.previousVersion || '—'}</dd>
                    <dt>{t('experiment')}</dt><dd>{control.experimentId || '—'}</dd>
                    <dt>{t('revision')}</dt><dd>{control.revision} · {control.policyVersion}</dd>
                </dl> : <p>{t('unavailable')}</p>}
                <p className="mb-0 text-muted">{t('globalSwitch')}</p>
            </div></section>
            <fieldset disabled={disabled}>
                <section className="card mb-4"><div className="card-body">
                    <h2>{t('reason')}</h2>{input('reason', 'reasonHint')}
                </div></section>
                <section className="card mb-4"><div className="card-body">
                    <h2>{t('modelTitle')}</h2>
                    <form onSubmit={e => { e.preventDefault(); this.loadModel(this.state.version); }}>
                        <label htmlFor="learning-version">{t('version')}</label>
                        <div className="input-group mb-3"><input id="learning-version" className="form-control" value={this.state.version}
                            maxLength={150} onChange={e => this.changeVersion(e.target.value)} />
                            <div className="input-group-append"><button className="btn btn-outline-primary" disabled={inspecting}>{t('lookup')}</button></div></div>
                    </form>
                    {control && <div className="mb-3">
                        {control.activeVersion && <button className="btn btn-link pl-0" onClick={() => this.loadModel(control.activeVersion)}>{t('viewActive')}</button>}
                        {control.previousVersion && <button className="btn btn-link" onClick={() => this.loadModel(control.previousVersion)}>{t('viewPrevious')}</button>}
                    </div>}
                    {inspecting && <p role="status">{t('loading')}</p>}
                    {model && <><dl className="learning-state">
                        <dt>{t('version')}</dt><dd>{model.modelVersion}</dd>
                        <dt>{t('status')}</dt><dd>{model.status} · {model.stage}</dd>
                        <dt>{t('documents')}</dt><dd>{model.documentCount == null ? '—' : model.documentCount}</dd>
                        <dt>{t('baseline')}</dt><dd>{model.comparisonBaselineId || '—'}</dd>
                        <dt>{t('artifact')}</dt><dd className="learning-hash">{model.artifactHash || '—'}</dd>
                    </dl><button className="btn btn-primary" disabled={model.status !== 'READY'} onClick={this.activate}>
                        {t(control && control.previousVersion === model.modelVersion ? 'rollback' : 'activate')}
                    </button><p className="text-muted mt-2 mb-0">{t('activateHint')}</p></>}
                </div></section>
                <section className="card mb-4"><div className="card-body">
                    <h2>{t('policyTitle')}</h2>
                    <form onSubmit={this.savePolicy}>
                        <div className="form-group"><label htmlFor="learning-mode">{t('mode')}</label>
                            <select id="learning-mode" className="form-control" value={this.state.mode} onChange={e => this.setState({ mode: e.target.value })}>
                                <option value="OFF">OFF — {t('off')}</option><option value="SHADOW">SHADOW — {t('shadow')}</option><option value="ON">ON — {t('on')}</option>
                            </select></div>
                        {input('traffic', 'traffic', 'number')}{input('experiment', 'experiment')}
                        <div className="form-check mb-3"><input id="learning-auto" className="form-check-input" type="checkbox"
                            checked={this.state.autoPromote} onChange={e => this.setState({ autoPromote: e.target.checked })} />
                            <label className="form-check-label" htmlFor="learning-auto">{t('autoPromote')}</label></div>
                        <button className="btn btn-primary" type="submit">{t('savePolicy')}</button>
                    </form>
                </div></section>
                <section className="card mb-4"><div className="card-body">
                    <h2>{t('blockTitle')}</h2><p className="text-muted">{t('blockHint')}</p>
                    <div className="form-group"><label htmlFor="learning-scope">{t('app')}</label>
                        <select id="learning-scope" className="form-control" value={this.state.scope} onChange={e => this.setState({ scope: e.target.value })}>
                            <option value="com.vnapp.iKara">com.vnapp.iKara</option><option value="co.ikara.v2">co.ikara.v2</option>
                        </select></div>
                    <div className="form-group"><label htmlFor="learning-block-type">{t('blockType')}</label>
                        <select id="learning-block-type" className="form-control" value={this.state.blockType} onChange={e => this.setState({ blockType: e.target.value })}>
                            <option value="REWRITE">{t('rewrite')}</option><option value="BEAT">{t('beat')}</option>
                        </select></div>
                    {input('source', 'source')}{this.state.blockType === 'REWRITE' ? input('target', 'target') : input('beatId', 'beatId')}
                    <button className="btn btn-danger mr-2" onClick={() => this.saveBlock(true)}>{t('block')}</button>
                    <button className="btn btn-outline-secondary" onClick={() => this.saveBlock(false)}>{t('unblock')}</button>
                </div></section>
            </fieldset>
            {busy && <p role="status">{t('saving')}</p>}
        </main>;
    }
}

export default SearchBeatLearningPage;
